/** @file newPuppet: the puppet `puppet.create` makes: one root node and nothing else. */
import type { Puppet } from '@zilo/pose3d-format/types/puppet';

/** A puppet with node `root` at the origin, empty drawables, sheets, sockets and variants, bounds `[1, 1, 2]`. */
export function newPuppet(id: string, name: string, profile: string, facing: Puppet['facing'] = { steps: 16, turnRate: 5 }): Puppet {
  return {
    format: 'pose3d/puppet@1', id, name, profile, facing: { ...facing }, nodes: { root: { pos: [0, 0, 0] } },
    sockets: {}, drawables: [], variants: [], sheets: {}, bounds: [1, 1, 2],
  };
}
